import { useState } from "react";
import { ArrowUp, Loader2 } from "lucide-react";

export const Composer = ({ onSubmit, busy, placeholder }) => {
  const [text, setText] = useState("");
  const send = () => {
    if (!text.trim() || busy) return;
    onSubmit(text.trim());
    setText("");
  };
  return (
    <div className="what-composer">
      <textarea
        data-testid="ask-question-textarea"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
        rows={2}
        placeholder={placeholder || "Ask once. Get the best of every AI."}
        className="flex-1 resize-none bg-transparent outline-none text-[15px] text-slate-100 placeholder:text-slate-500 leading-relaxed py-1"
      />
      <button data-testid="submit-question-btn" onClick={send} disabled={busy || !text.trim()} className="what-send" aria-label="Ask">
        {busy ? <Loader2 size={18} className="animate-spin" /> : <ArrowUp size={18} />}
      </button>
    </div>
  );
};
